import { isValid } from 'date-fns';
import { formatLocalDate } from '@/lib/utils/common/dateFormats';

export const DEFAULT_DATE_FORMAT = 'dd MMM, yyyy';

export const defaultFormatDate = (date?: string): string => {
  if (!date) return '';
  return !isValid(new Date(date)) ? date : formatLocalDate(date, DEFAULT_DATE_FORMAT);
};
